export interface Rectangle {
    height: number;
    width: number;
}

export interface Position {
    bottom: number;
    left: number;
    right: number;
    top: number;
}

export interface OverflowParent extends Position {
    scrollHeight: number;
    scrollWidth: number;
    clientHeight: number;
    clientWidth: number;
}

export interface ExtensionRect extends Rectangle, Position {
    overflowParent?: OverflowParent;
}
